import { restfulClient, actionClient } from '@/api'
import { cloneDeep } from 'lodash'

const specialPageUrl = '/page-config/special-page'
export const exportPageFormUrl = 'page-config/special-page-form-excel'

export function getSpecialPageList(searchForm) {
  let queryParams = cloneDeep(searchForm)
  if (searchForm.query.title) {
    queryParams.query.title = `%${searchForm.query.title}%`
  }
  return restfulClient.getCollection(specialPageUrl, queryParams)
}

export function createSpecialPage(params) {
  return restfulClient.create(specialPageUrl, params)
}

export function delSpecialPage(id) {
  return restfulClient.remove(specialPageUrl, id)
}
export const updateSpecialPage = (id, params) => restfulClient.update(specialPageUrl, id, params)
export const getSpecialPage = id => restfulClient.getDocument(specialPageUrl, id)
